import { type ParseSpreadsheetFail, type ParseSpreadsheetStart, type ParseSpreadsheetSuccess, SpreadsheetActionTypes } from './actions';
import type { GenericSheet } from './parser/types';

import type { DomainNames } from '../../types';

export const parseSpreadsheetStart = (domain: DomainNames, file: File): ParseSpreadsheetStart => ({
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_START,
  domain,
  payload: file,
});

export const parseSpreadsheetFail = (domain: DomainNames): ParseSpreadsheetFail => ({
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_FAIL,
  domain,
});

export const parseSpreadsheetSuccess = <T = any>(domain: DomainNames, results: GenericSheet<T>): ParseSpreadsheetSuccess => ({
  type: SpreadsheetActionTypes.PARSE_SPREADSHEET_SUCCESS,
  domain,
  payload: results,
});
